
export enum InvoiceStatus {
    None = 0,
    Pending = 1,
    HandledExternally = 2,
    Paid = 3,
    Cancelled = 4,
    Created = 5,
}
